export const HANDLE_PROJECT_NAME = "HANDLE_PROJECT_NAME";
export const API_STATUS = "API_STATUS";
export const HANDLE_PARAMETER_LIST = "HANDLE_PARAMETER_LIST";
export const PROJECTS_PARAMETERS = "PROJECTS_PARAMETERS";
export const INVESTIGATION_TABLE_DATA = "INVESTIGATION_TABLE_DATA";
export const FILTERD_REPORTS_DATA_LIST = "FILTERD_REPORTS_DATA_LIST";
export const PREVIEW_BATCH_RECORDS = "PREVIEW_BATCH_RECORDS";
export const PROJECT_NAME_API_STATUS = "PROJECT_NAME_API_STATUS";
export const GET_VISUALIZATION_DETAILS = "GET_VISUALIZATION_DETAILS";
export const VISUALIZATION_SUBMIT_RESULT = "VISUALIZATION_SUBMIT_RESULT";
export const VISUALIZATION_SUBMIT_QUERY = "VISUALIZATION_SUBMIT_QUERY";
export const VISUALIZATION_DATA_HISTORY = "VISUALIZATION_DATA_HISTORY";
export const GET_VISUALIZATION_PROJECTS = "GET_VISUALIZATION_PROJECTS";
export const GET_FILES_FOR_PREVIEW_LIST = "GET_FILES_FOR_PREVIEW_LIST";
export const EXPORT_INVESTIGATION_DATA_API_STATUS =
  "EXPORT_INVESTIGATION_DATA_API_STATUS";
export const GET_TASKS_DATA = "GET_TASKS_DATA";
export const API_STATUS_MASTER = "API_STATUS_MASTER";
export const PRODUCT_TYPE_BATCH_NAME_USER_NAME =
  "PRODUCT_TYPE_BATCH_NAME_USER_NAME";
export const DASHBOARD_LOG_TILES_DATA = "DASHBOARD_LOG_TILES_DATA";
export const BATCH_NAMES = "BATCH_NAMES";
export const BATCH_TILES_DATA = "BATCH_TILES_DATA";
export const BATCH_DOCUMENTS = "BATCH_DOCUMENTS";
export const BATCH_PARAMETERS = "BATCH_PARAMETERS";
export const BATCH_LOGS = "BATCH_LOGS";
export const GET_PROJECTS_AND_BATCHES_WITH_STATUS_COUNTS =
  "GET_PROJECTS_AND_BATCHES_WITH_STATUS_COUNTS";
export const GET_DRUG_PRODUCTS = "GET_DRUG_PRODUCTS";
export const GET_COUNTS_PER_DRUG_PRODUCTS = "GET_COUNTS_PER_DRUG_PRODUCTS";
export const GET_PROJECT_AND_BATCHES = "GET_PROJECT_AND_BATCHES";
export const GET_BATCH_STATUS = "GET_BATCH_STATUS";
export const GET_BATCH_STATUS_TILES = "GET_BATCH_STATUS_TILES";
export const GET_BATCH_TILES_DATA = "GET_BATCH_TILES_DATA";
export const GET_BATCH_TILES_FILTERS_DATA = "GET_BATCH_TILES_FILTERS_DATA";
export const GET_BATCH_LOGS_FILTERS_DATA = "GET_BATCH_LOGS_FILTERS_DATA";
export const GET_ALL_BATCH_TILES_API_STATUS = "GET_ALL_BATCH_TILES_API_STATUS";
export const GET_ALL_PREVIOUS_REPORTS_LIST_API_STATUS =
  "GET_ALL_PREVIOUS_REPORTS_LIST_API_STATUS";
export const API_STATUS_GET_LOGS = "API_STATUS_GET_LOGS";
export const GET_LOG_PDF_URL = "GET_LOG_PDF_URL";
export const INVESTIGATION_SEARCH_API_STATUS =
  "INVESTIGATION_SEARCH_API_STATUS";
export const DASHBOARD_TILES_API_STATUS_MASTER =
  "DASHBOARD_TILES_API_STATUS_MASTER";
export const GET_OUT_PUT_URL = "GET_OUT_PUT_URL";
